import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';

export const kymw72Handlers = [
  // 運営商品一覧取得 /kymw72/getOperationGoodsList
  http.post(PlessService.SERVICE.getOperationGoodsList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getOperationGoodsList.url, req);
    return HttpResponse.json(getOperationGoodsListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 運営商品削除 /kymw72/deleteOperationGoods
  http.post(PlessService.SERVICE.deleteOperationGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.deleteOperationGoods.url, req);
    return HttpResponse.json(deleteOperationGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

 // 運営商品登録 /kymw72/registOperationGoods
 http.post(PlessService.SERVICE.registOperationGoods.url, async ({ request }) => {
  const req = await request.json();
  console.log(PlessService.SERVICE.registOperationGoods.url, req);
  return HttpResponse.json(registOperationGoodsResponse);
  // return ResponseUtils.getSysError();
  // return ResponseUtils.getE0100();
  // return ResponseUtils.get500();
}),

  // 運営商品取得 /kymw72/getOperationGoods
  http.post(PlessService.SERVICE.getOperationGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getOperationGoods.url, req);
    return HttpResponse.json(getOperationGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 運営商品更新 /kymw72/updateOperationGoods
  http.post(PlessService.SERVICE.updateOperationGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateOperationGoods.url, req);
    return HttpResponse.json(updateOperationGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 企画確定済み媒体数取得 /kymw72/countFixtation
  http.post(PlessService.SERVICE.countFixtation.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.countFixtation.url, req);
    return HttpResponse.json(countFixtationResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getOperationGoodsListResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      TotalNum: "500",
      StartDispNum: "1",
      EndDispNum: "100",
      OperationGoodsList: [
        // {
        //   OperationGoodsId: "999",
        //   OperationGoodsStatusCode: "1",
        //   OperationGoodsStatusName: "999",
        //   DeliveryDivCode: "1",
        //   DeliveryDivName: "999999",
        //   OrderNum: "999999",
        //   CoopCodeList: ["い", "とう"],
        //   PlanningManagementDivCode: "01",
        //   PlanningManagementDivName: "9999999999999999",
        //   PlanningManagementDetailDivCode: "0102",
        //   PlanningManagementDetailDivName: "99999999999999999999999999999999",
        //   OrderReceptionStartCatalog: "20240101",
        //   OrderReceptionEndCatalog: "99999999",
        //   DepositCapitalIncreasePatternCode: "1",
        //   DepositCapitalIncreasePatternName: "999999999",
        //   DepositCapitalIncreaseCount: "999",
        //   UnitPrice: "999999999",
        //   FormFlyerCode: "999999999",
        //   PointNumber: "999999999",
        //   PauseGroupCode: "X",
        //   PdDivCode: "04",
        //   PdDivName: "99999999999999999999999999",
        //   DeliveryLeadDivCode: "01",
        //   DeliveryLeadDivName: "9999999999",
        //   GoodsName: "999999999999999999999999999999",
        //   GoodsNameKana: "999999999999999",
        //   StandardName: "99999999999999999999",
        //   StandardNameKana: "9999999999",
        //   AppropriatingClassCode: "01",
        //   AppropriatingClassName: "999999999999999999999999",
        //   ConsumeTaxDivCode: "1",
        //   ConsumeTaxDivName: "99999999999999",
        //   ConsumeTaxRate: "999"
        // }, {
        //   OperationGoodsId: "",
        //   OperationGoodsStatusCode: "",
        //   OperationGoodsStatusName: "",
        //   DeliveryDivCode: "",
        //   DeliveryDivName: "",
        //   OrderNum: "",
        //   CoopCodeList: [],
        //   PlanningManagementDivCode: "",
        //   PlanningManagementDivName: "",
        //   PlanningManagementDetailDivCode: "",
        //   PlanningManagementDetailDivName: "",
        //   OrderReceptionStartCatalog: "",
        //   OrderReceptionEndCatalog: "",
        //   DepositCapitalIncreasePatternCode: "",
        //   DepositCapitalIncreasePatternName: "",
        //   DepositCapitalIncreaseCount: "",
        //   UnitPrice: "",
        //   FormFlyerCode: "",
        //   PointNumber: "",
        //   PauseGroupCode: "",
        //   PdDivCode: "",
        //   PdDivName: "",
        //   DeliveryLeadDivCode: "",
        //   DeliveryLeadDivName: "",
        //   GoodsName: "",
        //   GoodsNameKana: "",
        //   StandardName: "",
        //   StandardNameKana: "",
        //   AppropriatingClassCode: "",
        //   AppropriatingClassName: "",
        //   ConsumeTaxDivCode: "",
        //   ConsumeTaxDivName: "",
        //   ConsumeTaxRate: ""
        // }, {
        //   OperationGoodsId: "髙",
        //   OperationGoodsStatusCode: "髙",
        //   OperationGoodsStatusName: "﨑",
        //   DeliveryDivCode: "髙",
        //   DeliveryDivName: "😀",
        //   OrderNum: "髙",
        //   CoopCodeList: ["髙"],
        //   PlanningManagementDivCode: "髙",
        //   PlanningManagementDivName: "髙",
        //   PlanningManagementDetailDivCode: "髙",
        //   PlanningManagementDetailDivName: "髙",
        //   OrderReceptionStartCatalog: "髙",
        //   OrderReceptionEndCatalog: "髙",
        //   DepositCapitalIncreasePatternCode: "髙",
        //   DepositCapitalIncreasePatternName: "髙",
        //   DepositCapitalIncreaseCount: "髙",
        //   UnitPrice: "髙",
        //   FormFlyerCode: "髙",
        //   PointNumber: "髙",
        //   PauseGroupCode: "髙",
        //   PdDivCode: "髙",
        //   PdDivName: "髙",
        //   DeliveryLeadDivCode: "髙",
        //   DeliveryLeadDivName: "髙",
        //   GoodsName: "髙",
        //   GoodsNameKana: "髙",
        //   StandardName: "髙",
        //   StandardNameKana: "髙",
        //   AppropriatingClassCode: "髙",
        //   AppropriatingClassName: "髙",
        //   ConsumeTaxDivCode: "髙",
        //   ConsumeTaxDivName: "髙",
        //   ConsumeTaxRate: "髙"
        // }, {
        //   OperationGoodsId: "<>",
        //   OperationGoodsStatusCode: "<>",
        //   OperationGoodsStatusName: "<>",
        //   DeliveryDivCode: "<>",
        //   DeliveryDivName: "<>",
        //   OrderNum: "<>",
        //   CoopCodeList: ["<>"],
        //   PlanningManagementDivCode: "<>",
        //   PlanningManagementDivName: "<>",
        //   PlanningManagementDetailDivCode: "<>",
        //   PlanningManagementDetailDivName: "<>",
        //   OrderReceptionStartCatalog: "<>",
        //   OrderReceptionEndCatalog: "<>",
        //   DepositCapitalIncreasePatternCode: "<>",
        //   DepositCapitalIncreasePatternName: "<>",
        //   DepositCapitalIncreaseCount: "<>",
        //   UnitPrice: "<>",
        //   FormFlyerCode: "<>",
        //   PointNumber: "<>",
        //   PauseGroupCode: "<>",
        //   PdDivCode: "<>",
        //   PdDivName: "<>",
        //   DeliveryLeadDivCode: "<>",
        //   DeliveryLeadDivName: "<>",
        //   GoodsName: "<>",
        //   GoodsNameKana: "<>",
        //   StandardName: "<>",
        //   StandardNameKana: "<>",
        //   AppropriatingClassCode: "<>",
        //   AppropriatingClassName: "<>",
        //   ConsumeTaxDivCode: "<>",
        //   ConsumeTaxDivName: "<>",
        //   ConsumeTaxRate: "<>"
        // }, {
        {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }, {
          OperationGoodsId: "997",
          OperationGoodsStatusCode: "1",
          OperationGoodsStatusName: "承認待",
          DeliveryDivCode: "1",
          DeliveryDivName: "ウィークリー",
          OrderNum: "XXXXXX",
          CoopCodeList: ["い", "とう"],
          PlanningManagementDivCode: "01",
          PlanningManagementDivName: "増資",
          PlanningManagementDetailDivCode: "0101",
          PlanningManagementDetailDivName: "申込み増資",
          OrderReceptionStartCatalog: "20240101",
          OrderReceptionEndCatalog: "99999999",
          DepositCapitalIncreasePatternCode: "1",
          DepositCapitalIncreasePatternName: "無制限",
          DepositCapitalIncreaseCount: "9",
          UnitPrice: "12999",
          FormFlyerCode: "XXXXX",
          PointNumber: "999",
          PauseGroupCode: "X",
          PdDivCode: "04",
          PdDivName: "青果（共Ｃ直納）",
          DeliveryLeadDivCode: "01",
          DeliveryLeadDivName: "翌週",
          GoodsName: "商品名",
          GoodsNameKana: "ショウヒンメイカナ",
          StandardName: "規格名",
          StandardNameKana: "キカクメイカナ",
          AppropriatingClassCode: "01",
          AppropriatingClassName: "農産",
          ConsumeTaxDivCode: "1",
          ConsumeTaxDivName: "外税",
          ConsumeTaxRate: "99"
        }
      ]
    }
  }
}

const deleteOperationGoodsResponse = {
  status: "ok",
  message: "処理終了",
}

const registOperationGoodsResponse = {
  status: "ok",
  message: "処理終了",
}

const getOperationGoodsResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      OperationGoodsId: "12345678",
      OperationGoodsStatus: "1",
      // OperationGoodsStatus: "2",
      DeliveryDiv: "2",
      OrderNum: "202410",
      CoopCodeList: [
        "い",
        "と",
        "ぐ",
        "ち",
        "さ",
        "とう",
        "な",
        "に"
      ],
      PlanningManagementDiv: "01",
      PlanningManagementDetailDiv: "0102",
      OrderReceptionStartCatalog: "20240101",
      OrderReceptionEndCatalog: "99999999",
      DepositCapitalIncreasePattern: "1",
      DepositCapitalIncreaseCount: "",
      UnitPrice: "999",
      FormFlyerCode: "XXXXX",
      PointNumber: "999",
      PauseGroupCode: "X",
      PdDiv: "01",
      DeliveryLeadDiv: "01",
      GoodsName: "商品名",
      GoodsNameKana: "ショウヒンメイカナ",
      StandardName: "規格名",
      StandardNameKana: "キカクメイカナ",
      AppropriatingClass: "01",
      ConsumeTaxDiv: "1",
      ConsumeTaxRate: "0"
    }
  }
}

const updateOperationGoodsResponse = {
  status: "ok",
  message: "処理終了",
}

const countFixtationResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      CountFixtation: "0"
    }
  }
}